import { render, staticRenderFns } from "./coachBox.vue?vue&type=template&id=a7c0d0e6&scoped=true"
import script from "./coachBox.vue?vue&type=script&lang=js"
export * from "./coachBox.vue?vue&type=script&lang=js"
import style0 from "./coachBox.vue?vue&type=style&index=0&id=a7c0d0e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c0d0e6",
  null
  
)

export default component.exports